<template>
  <PuzzleSolved v-if="puzzleSolved"/>

  <div class="relative" v-else>

      <!--HEADER -->
      <header class="c-header">
          <div class="wrap">
              <div class="flex items-center">
                  <div class="c-header__timer w-1/3">
                      <Timer :isRunning="timerIsRunning" :timerId="puzzleTimerId"/>
                  </div>

                  <div class="c-header__chars text-center w-1/3">
                      {{ selectedChars }}
                  </div>

                  <!-- <button class="c-header__info flex justify-end w-1/3" @click="toggleInfo">
                      <div class="icon icon-info"></div>
                  </button> -->
              </div>
          </div>
      </header>

      <!--START/INFO SCREEN -->
      <div class="c-info" v-if="showInfo">
        <div class="wrap py-24 h-3/4">
          <div class="text-center px-16">
              <template v-if="textIntro">
                <h2 class="mb-8"><strong>{{ textIntro.title }}</strong></h2>

                <div class="inline-block py-4 px-8 bg-brand text-brandText mb-16">{{ puzzle.start_date|date }}</div>

                <div v-html="textIntro.body"></div>
              </template>

              <figure>
                  <video class="w-4/5 md:w-auto mx-auto" autoplay muted loop playsinline>
                      <source type="video/mp4" :src="introSrc">
                  </video>
              </figure>
          </div>

          <button class="c-button w-full mx-auto block" @click="toggleInfo">
              Begin aan de puzzel
          </button>
        </div>
      </div>

      <!--BONUS WORD SCREEN-->
      <PuzzleSolutionForm v-else-if="showSolutionForm"/>

      <!--PUZZLE-->
      <div v-else class="c-puzzle flex flex-col lg:flex-row items-center">
        <PuzzleGrid class="c-puzzle__body wrap lg:w-1/2 py-12 lg:py-0 h-full lg:h-3/4" />

        <div v-if="allNonBonusWordsFound" class="c-puzzle__footer wrap py-24 lg:w-1/2" ref="cta_solution">
          <div class="w-full lg:w-1/2 py-14 text-center">
              <div v-if="textUnscramble" v-html="textUnscramble.body" class="mb-8"></div>
              <div v-else class="mb-8">
                <p>U bent er bijna!</p>
              </div>

              <button class="c-button w-full" @click="handleShowSolutionForm">
                  <template v-if="textUnscramble && textUnscramble.button_text">
                      {{ textUnscramble.button_text }}
                  </template>
                  <template v-else>
                    Nu nog de laatste letters ontwarren
                  </template>
              </button>
          </div>
        </div>
      
        <div v-else class="c-puzzle__footer w-full lg:w-1/2 lg:h-3/4">
            <PuzzleHintList />
        </div>
      </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { find } from 'lodash'

  import isInViewport from '@/utils/isInViewport'

  import Timer from '@/components/Timer'
  import PuzzleGrid from '@/components/puzzle/PuzzleGrid'
  import PuzzleHintList from '@/components/puzzle/PuzzleHintList'
  import PuzzleSolutionForm from '@/components/puzzle/PuzzleSolutionForm'
  import PuzzleSolved from '@/components/puzzle/PuzzleSolved'
  // const baseUrl = process.env.MIX_APP_URL
  const baseUrl = window.BASE_URL

  export default {
    name: 'Puzzle',

    data () {
      return {
        showInfo: true,
        showSolutionForm: false,
        timerIsRunning: false,
        baseUrl: baseUrl
      }
    },

    created () {
      const component = this

      if ((this.foundWordIds && this.foundWordIds.length) || this.$route.query['skip-intro']) {
        this.toggleInfo()
      }

      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
          if (component.showInfo) {
            return
          }

          component.timerIsRunning = true
        } else {
          component.timerIsRunning = false
        }
      });

      // window.addEventListener('blur', function () {
      //   component.timerIsRunning = false
      // })
      //
      // window.addEventListener('focus', function () {
      //   if (component.showInfo) {
      //     return
      //   }
      //
      //   component.timerIsRunning = true
      // })
    },

    methods: {
      toggleInfo () {
        this.showInfo = !this.showInfo

        if (!this.showInfo) {
            this.timerIsRunning = true
            this.scrollToTop()
        }
      },

      handleShowSolutionForm () {
        this.showSolutionForm = true
        this.scrollToTop()
      },

      scrollToTop () {
        if (!this.$el) {
          return
        }

        this.$SmoothScroll(this.$el, 500)
      }
    },

    watch: {
      puzzleSolved: function (newValue) {
        if (newValue) {
          this.scrollToTop()
        }
      },

      allNonBonusWordsFound: {
        handler: function (newValue) {
            if (!newValue) {
              return
            }

            this.$nextTick(() => {
              const element = this.$refs.cta_solution

              if (!element || isInViewport(element)) {
                return
              }

              this.$SmoothScroll(element, 500)
            })
        },
        immediate: true
      }
    },

    computed: {
      ...mapGetters([
        'allNonBonusWordsFound',
        'puzzleSolved',
        'selectedChars',
        'puzzleTimerId'
      ]),

      ...mapState({
        puzzle: state => state.currentPuzzle,
        texts: state => state.texts,
        foundWordIds: state => state.foundWordIds,
        gridSettings: state => state.gridSettings
      }),

      textIntro () {
        return this.$store.getters.textByRealm({ realm: 'intro' })
      },

      textUnscramble () {
        return this.$store.getters.textByRealm({ realm: 'unscramble' })
      },

      introSrc () {
        let filename = 'raadsel.mp4'

        const brand = window.BRAND
        if (['gva', 'hbvl'].indexOf(brand) !== -1) {
          filename = `raadsel_${brand}.mp4`
        }

        return `${baseUrl}/assets/images/${filename}`
      }
    },

    components: {
      Timer,
      PuzzleGrid,
      PuzzleHintList,
      PuzzleSolutionForm,
      PuzzleSolved
    }
  }
</script>
